import L from 'leaflet'
import { useMemo } from 'react'
import { CircleMarker, Marker, useMap } from 'react-leaflet'
import { ICluster } from 'src/generated-types/cluster'
import { getMidPoint } from 'src/utils'
import { makeStyles } from 'tss-react/mui'

interface IClusterLayer {
  cluster: ICluster
}
const useStyles = makeStyles()({
  clusterCount: {
    color: 'white',
    background: 'transparent',
    fontSize: '16px',
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

const ClusterLayer = ({ cluster }: IClusterLayer) => {
  const color = cluster.hasDeviation ? '#D32F2F' : '#00536c'
  const map = useMap()
  const { classes } = useStyles()

  const latitude = useMemo(() => getMidPoint(cluster.latitude), [cluster])
  const longitude = useMemo(() => getMidPoint(cluster.longitude), [cluster])

  const onClusterClick = () => {
    map.setView([latitude, longitude], 9, { duration: 1000, animate: true })
  }

  return (
    <>
      <CircleMarker
        fillColor={color}
        center={[latitude, longitude]}
        stroke={false}
        radius={40}
        fillOpacity={0.2}
        eventHandlers={{ click: () => onClusterClick() }}
      >
        <CircleMarker fillOpacity={0.4} fillColor={color} center={[latitude, longitude]} stroke={false} radius={32}>
          <CircleMarker
            fillOpacity={0.6}
            fillColor={color}
            center={[latitude, longitude]}
            stroke={false}
            radius={25}
          ></CircleMarker>
        </CircleMarker>
      </CircleMarker>
      <Marker
        eventHandlers={{ click: () => onClusterClick() }}
        position={[latitude, longitude]}
        icon={L.divIcon({
          html: `<span>${cluster.number}</span>`,
          className: classes.clusterCount,
          iconSize: [50, 50],
        })}
      />
    </>
  )
}

export default ClusterLayer
